import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informe-habeas-data',
  templateUrl: './informe-habeas-data.component.html',
  styleUrls: ['./informe-habeas-data.component.css']
})
export class InformeHabeasDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
